export const deviceParams = {
  lifestyle: {
    category: `LS`
  },
  malls: {
    category: `ML`
  },
  spbu: {
    category: `BU`
  },
  airport: {
    category: `AR`
  }
}

export const experienceParams = {
  lifestyle: {
    category: `LS`
  },
  malls: {
    category: `ML`
  },
  spbu: {
    category: `BU`
  },
  airport: {
    category: `AR`
  }
}

export const discoveryParams = {
  lifestyle: {
    category: `LS`
  },
  malls: {
    category: `ML`
  },
  spbu: {
    category: `BU`
  },
  airport: {
    category: `AR`
  },
  airlines: {
    category: `AL`
  }
}

export const airlinesParams = {
  am_lcd: {
    property_type: `LC`
  },
  am_lightbox: {
    property_type: `LB`
  },
  aircraft_livery: {
    property_type: `AL`
  },
  avod: {
    property_type: `AV`
  },
  checkin_counter: {
    property_type: `CC`
  },
  magazine: {
    property_type: `MZ`
  },
  material_branding: {
    property_type: `MB`
  },
  office: {
    property_type: `OF`
  },
  sampling: {
    property_type: `SL`
  },
  wifi: {
    property_type: `WF`
  }
}

export const paginationParams = {
  page: 1
}

export const pageParams = {
  homepage: 'homepage',
  digitalscreen: 'digitalscreen'
}
